import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Auth interceptor - ensures cookies are sent with all requests
 * Cookies are automatically included for same-origin requests
 * For cross-origin, we need to explicitly set withCredentials
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip setting credentials for S3 uploads
  // S3 presigned URLs don't need cookies and use wildcard CORS (*)
  // which doesn't work with credentials
  const isS3Upload = req.url.includes('amazonaws.com') || req.url.includes('s3.');

  if (isS3Upload) {
    // Don't modify S3 requests - let them use their own withCredentials setting
    return next(req);
  }

  // Ensure credentials (cookies) are sent with all other requests
  // This is important for cookie-based authentication
  const clonedReq = req.clone({
    setHeaders: {},
    withCredentials: true,
  });

  return next(clonedReq);
};
